// extracted by mini-css-extract-plugin
export default {"container":"plans-carousel-module--container--b9d00","title":"plans-carousel-module--title--03f69","includes":"plans-carousel-module--includes--c4b6c"};